/* Scroll poses are deterministic: scrolling backwards retraces the same scene. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.TakeBagOfficialJourney=api;})(typeof window==='object'?window:this,function(){
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
  const mix=(a,b,t)=>a+(b-a)*t;
  const ease=t=>t*t*(3-2*t);
  function pose(progress,width,height,narrow){
    const p=clamp(progress),base=narrow?Math.min(310,height*.44):Math.min(480,width*.38,height*.82);
    const frames=narrow?[
      [0,.50,.63,1,-11,1,.79,.69,.75,-18,0],
      [.22,.49,.63,1.10,-3,1,.79,.69,.75,-18,0],
      [.36,.49,.63,1.10,3,1,.79,.69,.75,-18,0],
      [.53,.29,.66,.69,-13,.24,.61,.64,1.08,8,1],
      [.66,.29,.66,.69,-13,.24,.61,.64,1.08,3,1],
      [.84,.35,.62,.94,-5,1,.68,.62,.752,5,1],
      [1,.35,.62,.94,-3,1,.68,.62,.752,3,1]
    ]:[
      [0,.72,.50,1,-11,1,.87,.65,.75,-18,0],
      [.22,.74,.50,1.11,-3,1,.87,.65,.75,-18,0],
      [.36,.74,.50,1.11,3,1,.87,.65,.75,-18,0],
      [.53,.59,.60,.65,-13,.22,.77,.51,1.05,9,1],
      [.66,.59,.60,.65,-13,.22,.77,.51,1.05,3,1],
      [.84,.65,.52,.90,-5,1,.83,.52,.72,5,1],
      [1,.65,.52,.90,-3,1,.83,.52,.72,3,1]
    ];
    let i=0;while(i<frames.length-2&&p>frames[i+1][0])i++;
    const a=frames[i],b=frames[i+1],t=ease(clamp((p-a[0])/(b[0]-a[0])));
    const v=a.map((n,j)=>mix(n,b[j],t));
    const bag={x:v[1]*width,y:v[2]*height,size:v[3]*base,angle:v[4],opacity:v[5]};
    const bottle={x:v[6]*width,y:v[7]*height,size:v[8]*base,angle:v[9],opacity:v[10]};
    const join=ease(clamp((p-.70)/.14));
    bottle.y=mix(bottle.y,bag.y+bag.size*.40-bottle.size*.375,join);
    const chapter=p<.18?0:p<.43?1:p<.74?2:3;
    return {bag,bottle,chapter,detail:clamp(1-Math.abs(p-.29)/.14),join};
  }
  return {pose};
});
